import { stylePropertyPrefixes } from '../components/core/swan-style.util.js';

// TODO: For Swan v2.0: Remove `scopedFontNew` and `scopedFontLegacy`
const ROOT_CLASSNAMES = {
  base: 'swan',
  scopedFontNew: 'swan-scoped-font-scale-new',
  scopedFontLegacy: 'swan-scoped-font-scale-legacy',
  darkMode: "swan-".concat(stylePropertyPrefixes.darkMode),
  lightMode: "swan-".concat(stylePropertyPrefixes.lightMode),
  themeHoliday: "swan-theme-holiday"
};
export { ROOT_CLASSNAMES };